import * as Sentry from '@sentry/react';

/**
 * Sentry configuration and context setup
 */

export const setupSentryContext = () => {
  if (import.meta.env.PROD) {
    // Set essential global context only
    Sentry.setContext('app', {
      name: 'Worknity',
      version: import.meta.env.VITE_APP_VERSION || '1.0.0',
      environment: import.meta.env.MODE,
      buildTime: new Date().toISOString()
    });

    // Set essential global tags
    Sentry.setTag('platform', 'web');
    Sentry.setTag('framework', 'react');
    Sentry.setTag('environment', import.meta.env.MODE);

    // Set browser context (essential for debugging)
    Sentry.setContext('browser', {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      onLine: navigator.onLine
    });

    // Set URL context (essential for debugging)
    Sentry.setContext('url', {
      href: window.location.href,
      pathname: window.location.pathname
    });
  }
};
